import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';
import HasSomeRights from 'nallian-shared-ui/lib/layout/rights/HasSomeRights';
import { Flex, Header, Segment, Divider, Link, Button } from 'nallian-shared-ui/lib/components';
import AppSubscriptionFeature from './AppSubscriptionFeature';
import { APP_SUBSCRIPTION_ACTIONS } from '../../constants';

const ORGANISATION_APP_RIGHTS = [
  'ORGANISATIONAPPS.MANAGE.ALL',
  'ORGANISATIONAPPS.MANAGE.ALL.EXCEPTSYSTEMORGS',
  'ORGANISATIONAPPS.MANAGE.ORGANISATION',
];

const AppSubscription = ({
  forbidManageBecauseSystemOrg,
  handleRemoveFeature,
  availableCommunityApps,
  isLast,
  organisationApp,
  urlRoot,
}) => {
  const { t } = useTranslation();

  const availableCommunityApp = useMemo(
    () => availableCommunityApps.find(c => c.id === organisationApp.id),
    [availableCommunityApps, organisationApp]
  );

  return (
    <Flex fluid direction="column">
      <Flex fluid margin="0 0 -0.4rem">
        <Header as="h4">
          {organisationApp?.alias || organisationApp?.appInstallation?.name} (
          {organisationApp?.community?.name})
        </Header>
      </Flex>
      <Segment secondary>
        <Table basic="very">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width="6">{t('feature')}</Table.HeaderCell>
              <Table.HeaderCell width="6">{t('validPeriod')}</Table.HeaderCell>
              <Table.HeaderCell width="2" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {(organisationApp.communityAppFeatures || []).map(feature => (
              <AppSubscriptionFeature
                forbidManageBecauseSystemOrg={forbidManageBecauseSystemOrg}
                urlRoot={urlRoot}
                feature={feature}
                key={feature.id}
                organisationApp={organisationApp}
                handleRemoveFeature={handleRemoveFeature}
              />
            ))}
            {organisationApp?.communityAppFeatures?.length <
              (availableCommunityApp?.communityAppFeatures || []).length && (
              <Table.Row>
                <Table.Cell />
                <Table.Cell />
                <Table.Cell textAlign="right">
                  {!forbidManageBecauseSystemOrg && (
                    <HasSomeRights rights={ORGANISATION_APP_RIGHTS}>
                      <Link
                        to={`${urlRoot}/app-subscriptions/${
                          APP_SUBSCRIPTION_ACTIONS.NEW_FEATURE
                        }${`?communityAppId=${organisationApp.id}`}`}
                      >
                        <Button linkbutton icon="plus" content={t('addFeature')} />
                      </Link>
                    </HasSomeRights>
                  )}
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Segment>
      {!isLast && <Divider />}
    </Flex>
  );
};

AppSubscription.propTypes = {
  urlRoot: PropTypes.string.isRequired,
  availableCommunityApps: PropTypes.array.isRequired,
  organisationApp: PropTypes.object.isRequired,
  handleRemoveFeature: PropTypes.func.isRequired,
  forbidManageBecauseSystemOrg: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
};

export default AppSubscription;
